<template>
  <footer>
    <div class="footer clearfix">
      <div class="row">
        <div class="offset-1 col-lg-3 copy">
          <div class="d-flex align-items-center flex-column">
          <span class="flex-1">&copy; {{ year }} - <router-link to="/">domcek.org</router-link> Všetky práva vyhradené</span>

          <div>
            <a href="/page/pute/ochrana-osobnych-udajov-1">Pravidla Ochrany osobných údajov</a></div>
            </div>
        </div>
        <div class="col-lg-4 text-center">
          <div class="col col-8 offset-2">
            <a href="https://annakolesarova.sk" rel="noreferrer" target="_blank" class="img-fluid">
              <img src="/img/logo_AK_horizontalne_inv.png"
                 alt="anka logo"/>
            </a>
          </div>
        </div>
        <div class="offset-right-1 col-lg-3 icons">
          <h3 class="text-uppercase">Sme aj na</h3>
          <hr/>
          <a href="https://www.facebook.com/AnkaKolesarovaMucenickaCistoty/" target="_blank" rel="noreferrer">
            <span class="fa fa-facebook-f"></span>
          </a>
          <a href="https://www.facebook.com/domankykolesarovej/" target="_blank" rel="noreferrer">
            <span class="fa fa-facebook-f"></span>
          </a>
          <a href="https://www.youtube.com/user/DomAnkyKolesarovej" target="_blank" rel="noreferrer">
            <span class="fa fa-youtube"></span>
          </a>
          <a href="tel:+421911 912 598">
            <span class="fas fa-phone"></span>
          </a>
          <a href="mailto:domcek@domcek.org">
            <span class="fas fa-envelope"></span>
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import dayjs from 'dayjs';

export default {
  name: 'Footer',
  computed: {
    year() {
      const d = dayjs();
      return d.year();
    }
  },
};
</script>
